unit NetNumberStatusItemType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TNetNumberStatusItemType = class
  private
    fNetNumberStatusKey: String;
    fNetStatus: String;
    fStatusDate: String;
    fStatusTime: String;
  public
    property NetNumberStatusKey: String read fNetNumberStatusKey;
    property NetStatus: String read fNetStatus;
    property StatusDate: String read fStatusDate;
    property StatusTime: String read fStatusTime;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TNetNumberStatusItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fNetNumberStatusKey := String(JSObject_Type['netNumberStatusKey']);
    fNetStatus := String(JSObject_Type['netStatus']);
    fStatusDate := String(JSObject_Type['statusDate']);
    fStatusTime := String(JSObject_Type['statusTime']);
  end;
end;

end.
